<mat-sidenav-container autosize>
  <mat-sidenav
    #filtersSidenav
    class="right-sidenav"
    [mode]="'side'"
    autoFocus="false"
    fixedInViewport="true"
    position="end"
    [opened]="filtersSidenavOpenedByDefault"
    [mode]="filtersSidenavMode"
  >
    <suvo-bi-filters-sidenav [filtersChannel]="filtersChannel"></suvo-bi-filters-sidenav>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header>
      @if (filtersChannel) {
        <suvo-bi-active-filters-widget [filtersChannel]="filtersChannel" />
      }
    </app-header>

    <mat-card style="margin: 0 var(--global-padding)">
      <mat-card-header>
        <mat-card-title>Audit</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <app-audit-table tableAlias="audit" [filtersChannel]="filtersChannel" />
      </mat-card-content>
    </mat-card>
  </mat-sidenav-content>
</mat-sidenav-container>
